import React , { useState } from 'react'
import './MobDeal.css'
import Switch from "react-switch";


function MobDeal() {

    const [checked, setchecked] = useState(false);
    const [monthly, setmonthly] = useState(true);
    const [yearly, setyearly] = useState(false);

    const handleChange = () =>{
        if(checked){
            setchecked(false);
            setyearly(false);
            setmonthly(true);
        }else{
            setchecked(true);
            setyearly(true);
            setmonthly(false);
        }
    }


    return (
        <div id='mob_deal'>
             <h1>Get your best deal</h1>
             <div className='deal_type_container'>
                    <h2 className={monthly ? "deal_selected" : "deal_not_selected"}>Monthly</h2>
                    <Switch onChange={handleChange} 
                            checked={checked} 
                            checkedIcon={false} 
                            uncheckedIcon={false} 
                            offHandleColor="#A8FF35"
                            onHandleColor="#A8FF35"
                            offColor="#FAFAFA"
                            onColor="#FAFAFA"
                            />
                    <h2 className={yearly ? "deal_selected" : "deal_not_selected"}>Yearly</h2>
            </div>
            <div className='mob_deal_price_container'>
                <div className='mob_deal_price_box mob_selected_price'>
                            <div className='deal_price_title'>
                                <h1>Personal</h1>
                                <h2>Special first packet for all</h2>
                            </div>
                            <div className='deal_price_tag'>
                                <h1 style={{color: "grey", marginRight: "2vh"}}><s>$8</s></h1>
                                <h1>Free</h1>
                            </div>
                            <div className='deal_price_details'>
                                <div className='deal_price_details_info'>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                    </svg>
                                    <p>50 Queries Included pr. Month</p>
                                </div>
                                <div className='deal_price_details_info'>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                    </svg>
                                    <p>1 Project</p>
                                </div>
                                <div className='deal_price_details_info'>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                    </svg>
                                    <p>Email Moderation</p>
                                </div>
                            </div>
                            <div className='deal_price_button'>
                                <button style={{backgroundColor: "black", color: "white"}} >Get started </button>
                            </div>
                        </div> 
                </div>

                    <div className='mob_deal_price_box disabled'>
                        <div className='deal_price_title'>
                            <h1>Regular</h1>
                            <h2>Recommended for personal pro</h2>
                        </div>
                        <div className='deal_price_tag'>
                            <h1>$20</h1>
                            <div className='deal_price_tag_type'>
                                <h2>/Month</h2>
                            </div>
                        </div>
                        <div className='deal_price_details'>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>10 000 Queries Included pr. Month</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>10 Project</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>Email Moderation</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>Text Moderation</p>
                            </div>
                        </div>
                        <div className='deal_price_button'>
                            <button>Start Free Trial</button>
                        </div>
                    </div>  


                    <div className='mob_deal_price_box disabled'>
                        <div className='deal_price_title'>
                            <h1>Premium</h1>
                            <h2>Packet for Startup & Company</h2>
                        </div>
                        <div className='deal_price_tag'>
                            <h1>$48</h1>
                            <div className='deal_price_tag_type'>
                                <h2>/Month</h2>
                            </div>
                        </div>
                        <div className='deal_price_details'>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>Unlimited Queries</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>20+ Project</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>All types of Moderations</p>
                            </div>
                            <div className='deal_price_details_info'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                                    <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                </svg>
                                <p>Support</p>
                            </div>
                        </div>
                        <div className='deal_price_button'>
                            <button>Start Free Trial</button>
                        </div>
                    </div>  
        </div>
    )
}

export default MobDeal
